import { render, staticRenderFns } from "./function-action.vue?vue&type=template&id=585aec66&scoped=true&"
import script from "./function-action.vue?vue&type=script&lang=js&"
export * from "./function-action.vue?vue&type=script&lang=js&"
import style0 from "./function-action.vue?vue&type=style&index=0&id=585aec66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585aec66",
  null
  
)

export default component.exports